// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__2o7PD","footer":"ModalFilter_footer__2VxHz"};